import * as Yup from 'yup';

const collectedDataTypesSchema = Yup.object({
  data_types: Yup.array()
    .of(Yup.string().required('Each data type is required'))
    .min(1, 'At least one data type must be selected')
    .required('Data types are required'),
  other_data_types: Yup.string().when('data_types', ([dataTypes], schema) => {
    return dataTypes.includes('Other')
      ? schema.required('Specify other data type')
      : schema.notRequired();
  }),
});

const dataAccessScopeSchema = Yup.object({
  scope: Yup.array()
    .of(Yup.string().required('Each scope is required'))
    .min(1, 'At least one scope must be selected')
    .required('Data access scope is required'),
  other_scope: Yup.string().when('scope', ([scope], schema) => {
    return scope.includes('Other')
      ? schema.required('Specify other scope')
      : schema.notRequired();
  }),
});

export const thirdPartyEvaluationFormSchema = Yup.object({
  vendor_name: Yup.string(),
  product_name: Yup.string().nullable(),
  integration_scope: Yup.string(),
  vendor_ai_ml_usage: Yup.string().required(),
  vendor_usage_description: Yup.string().required('Required'),
  business_criticality: Yup.string().required('Required'),
  system_access_level: Yup.string().required('Required'),
  vendor_submitted_files: Yup.array()
    .min(1, 'At least one file is required')
    .required('At least one file is required'),
  isQuestionnaireRequired: Yup.boolean().required(),
  questionnaire_url: Yup.string().when(
    'isQuestionnaireRequired',
    ([isQuestionnaireRequired], schema) => {
      return isQuestionnaireRequired
        ? schema.required('Required')
        : schema.notRequired();
    }
  ),
  collected_data_types: collectedDataTypesSchema,
  data_access_scope: dataAccessScopeSchema,
  nature_of_relationship: Yup.string().required(
    'Nature of relationship is required'
  ),
  specify_relationship_type_other: Yup.string().when(
    'nature_of_relationship',
    ([natureOfRelationship], schema) => {
      return natureOfRelationship === 'Other'
        ? schema.required('Required')
        : schema.notRequired();
    }
  ),
});
